export const UserRole = {
  User: 0,
  Employee: 1,
  Lead: 2,
  PM: 3,
  Admin: 4
};
